import { EPeriodFilter } from '../../../../utils/app-models'

export const invoiceDefaultFilterConfigValues = {
	customer_list: null,
	period: EPeriodFilter.thisMonth,
}
